


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import VolverButton from '@/reusable/Modal/VolverButton.vue';
import ContinuarButton from '@/reusable/Modal/ContinuarButton.vue';
import GuardarCambiosButton from '@/reusable/Modal/GuardarCambiosButton.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { object } from 'yup';

@Component({
  components: { GuardarCambiosButton, ContinuarButton, VolverButton },
})
export default class CrudStepperHeader extends Vue {
  @Prop({ required: true }) pasos: PasosCrud;
  @Prop({ required: true }) pasoActivoIndex: number;

  contador: number = 0;

  @Watch('pasos', { immediate: true })
  async contadorPasos() {
    this.contador = 0;
    Object.values(this.pasos).forEach(value => {
      if (value.visible) {
        this.contador++;
      }
    });
  }
}
